import React from "react"
import PropTypes from "prop-types"
import _ from "lodash"

import { ORDENES, PRODUCTO_TODOS } from "../static"

const Segmento = ({ opciones, valor, onChange }) => (
  <div className="pv2-seg">
    {opciones.map(opcion => (
      <button
        key={opcion.value}
        type="button"
        className={`pv2-seg-btn${valor === opcion.value ? " is-on" : ""}`}
        onClick={() => onChange(opcion.value)}
      >
        {opcion.label}
      </button>
    ))}
  </div>
)

Segmento.propTypes = {
  opciones: PropTypes.array.isRequired,
  valor: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

const ComparatorToolbar = ({
  productos,
  producto,
  orden,
  busqueda,
  visibles,
  total,
  onChangeProducto,
  onChangeOrden,
  onChangeBusqueda,
}) => (
  <div className="pv2-toolbar">
    <div className="pv2-toolbar-group">
      <span className="pv2-mini-label">Producto</span>
      <Segmento
        opciones={[
          { value: PRODUCTO_TODOS, label: "Todos" },
          ...productos.map(nombre => ({
            value: nombre,
            label: _.capitalize(nombre),
          })),
        ]}
        valor={producto}
        onChange={onChangeProducto}
      />
    </div>
    <div className="pv2-toolbar-group">
      <span className="pv2-mini-label">Ordenar por</span>
      <Segmento opciones={ORDENES} valor={orden} onChange={onChangeOrden} />
    </div>
    <div className="pv2-search">
      <span className="pv2-search-icon">⌕</span>
      <input
        type="text"
        className="pv2-input"
        value={busqueda}
        onChange={event => onChangeBusqueda(event.target.value)}
        placeholder="Buscar proveedor o granja"
      />
    </div>
    <div className="pv2-toolbar-count">
      {visibles} de {total} disponibilidades
    </div>
  </div>
)

ComparatorToolbar.propTypes = {
  productos: PropTypes.array.isRequired,
  producto: PropTypes.string.isRequired,
  orden: PropTypes.string.isRequired,
  busqueda: PropTypes.string.isRequired,
  visibles: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onChangeProducto: PropTypes.func.isRequired,
  onChangeOrden: PropTypes.func.isRequired,
  onChangeBusqueda: PropTypes.func.isRequired,
}

export default ComparatorToolbar
